// Giá trị phải khớp LeagueFilter bên backend (leagues/enums/league-filter.enum.ts);
// gửi giá trị lạ là ăn 422.
export enum LeagueFilterStatusEnum {
    ONGOING = 'ONGOING',
    UPCOMING = 'UPCOMING',
    ENDED = 'ENDED',
    /** Đang trong khoảng đăng ký do ban tổ chức cấu hình. */
    REGISTRATION_OPEN = 'REGISTRATION_OPEN',
    /** Chưa tới ngày mở đăng ký. */
    REGISTRATION_UPCOMING = 'REGISTRATION_UPCOMING',
    /** Chưa qua ngày kết thúc — dùng cùng onlyMyLeagues cho "giải đang tham gia". */
    NOT_ENDED = 'NOT_ENDED',
}
